import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

export default function Navbar() {
  const { pathname } = useLocation();

  const isOwnerPreview = pathname.startsWith("/preview/");
  const isActivationSuccess = pathname === "/activation-success";

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-2xl bg-[#09090B]/70 border-b border-white/5"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 group"
          data-testid="nav-logo"
        >
          <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-[#00E5FF] text-black font-display font-bold text-sm group-hover:bg-[#66FFFF] transition-colors">
            T
          </span>

          <span className="font-display font-semibold tracking-tight text-lg">
            TapToTable
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-400">
          <a
            href="/#how"
            className="hover:text-white transition-colors"
            data-testid="nav-link-how"
          >
            How it works
          </a>

          <a
            href="/#pricing"
            className="hover:text-white transition-colors"
            data-testid="nav-link-pricing"
          >
            Pricing
          </a>

          <a
            href="/#faq"
            className="hover:text-white transition-colors"
            data-testid="nav-link-faq"
          >
            FAQ
          </a>
        </nav>

        {isOwnerPreview ? (
          <div
            className="inline-flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-4 py-2 text-sm font-semibold text-emerald-300"
            data-testid="nav-owner-preview-status"
            aria-label="Your TapToTable Page is already built"
          >
            <span aria-hidden="true">✓</span>
            <span>Your Page Is Built</span>
          </div>
        ) : isActivationSuccess ? (
          <div
            className="inline-flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-4 py-2 text-sm font-semibold text-emerald-300"
            data-testid="nav-activation-confirmed-status"
            aria-label="Your TapToTable activation is confirmed"
          >
            <span aria-hidden="true">✓</span>
            <span>Activation Confirmed</span>
          </div>
        ) : (
          <Link
            to="/signup"
            className="inline-flex items-center gap-2 rounded-full bg-[#00E5FF] text-black font-semibold text-sm px-4 py-2 hover:bg-[#66FFFF] hover:shadow-[0_0_20px_rgba(0,229,255,0.4)] transition-all"
            data-testid="nav-cta-signup"
            aria-current={pathname === "/signup" ? "page" : undefined}
          >
            Build My Page

            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M5 12h14M13 5l7 7-7 7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        )}
      </div>
    </motion.header>
  );
}
